import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileUploadComponent } from './file-upload.component';
import { DropZoneDirective } from '../../directives/drop-zone.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule
  ],
  declarations: [
    FileUploadComponent, 
    DropZoneDirective
  ],
  exports: [FileUploadComponent],
})
export class FileUploadModule { }


// WEBPACK FOOTER //
// ./src/app/uploads/file-upload/file-upload.module.ts